import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import {addSuccessMessage} from '../SnackBar';

export const COMPETITIONS_PATCH_REQUEST = 'PATCH_COMPETITIONS_REQUEST';
export const COMPETITIONS_PATCH_FAILURE = 'PATCH_COMPETITIONS_FAILURE';
export const COMPETITIONS_PATCH_SUCCESS = 'PATCH_COMPETITIONS_SUCCESS';

export const patchCompetition = (data, id) => {
    return function(dispatch) {
        const params = [];
        params['id'] = id;
        dispatch(patchRequest());
        return axios(apiRequestOptions(apiPath.COMPETITIONS.PATCH, data, {params}))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(patchSuccess(response.data));
                dispatch(addSuccessMessage('Competition successfully changed'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(patchFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const patchRequest = () => ({type: COMPETITIONS_PATCH_REQUEST});
const patchFailure = error => ({type: COMPETITIONS_PATCH_FAILURE, error});
const patchSuccess = competition => ({type: COMPETITIONS_PATCH_SUCCESS, competition});
